export class banner{
    _id:any;
    screenName:any;
    screenId:any;
    images:any;
    status:boolean
}